import {html, LitElement, TemplateResult,} from "lit";
import {customElement, property} from "lit/decorators.js";
import projectileStyles from "../../../../styles/minigames/dragoninvaders/projectileStyles";


@customElement("game-projectile")
export class GameProjectile extends LitElement {
    @property({type: Number}) private positionX: number = 0;
    @property({type: Number}) private positionY: number = 0;
    @property({type: String}) private shooter: "player" | "enemy" | undefined;

    public static styles = [projectileStyles];

    protected render(): TemplateResult {
        const projectileClass: string = `projectile ${this.shooter}Projectile`;
        return html`
            <div class="${projectileClass}"
                 style="left: ${this.positionX}px; top: ${this.positionY}px;"></div>
        `;
    }


}
